<template>
    <div>
        <DataTable :value="documents" lazy paginator dataKey="id"
            v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset"
            removableSort :totalRecords="totalRecords" :loading="loading" @page="onPage"
            @sort="onPage" :rowsPerPageOptions="[5,10,20,50]"
            v-model:filters="searchCriteria"
            filterDisplay="row" class="documents-table" scrollable
            scrollHeight="calc(100vh - 300px)">
            <Column field="timestamp" :header="$t('message.historyList.table.date')"
                :sortable="false" filterField="timestamp"
                :showFilterMenu="false" :showClearButton="false" class="w-1">
                <template #filter>
                    <CustomCalendar name="timestamp" v-model="searchCriteria.timestamp.value"  selectionMode="range"
                                    :showTime="false" placeholder="DD-MM-YYYY" dateFormat="dd-mm-yy" showButtonBar
                        @update:modelValue="search"/>
                </template>
            </Column>
            <Column field="userFullName" :header="$t('message.historyList.table.user')"
                :sortable="false" filterField="documentType"
                :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.userFullName }}
                </template>
                <template #filter>
                    <CustomInputText name="studbookRegistryId" v-model="searchCriteria.userFullName.value"
                         @update:modelValue="search" />
                </template>
            </Column>
            <Column field="role" :header="$t('message.historyList.table.role')"
                :sortable="false" filterField="studbookRegistryId"
                :showFilterMenu="false" :showClearButton="false" class="w-1">
                <template #body="{ data }">
                    {{ data.role }}
                </template>
                <template #filter>
                    <CustomSelectOneSystemRole name="systemRole"
                                               v-model="searchCriteria.role.value" noPlaceholder
                                               @update:modelValue="search" />
                </template>
            </Column>
            <Column field="actionType" :header="$t('message.historyList.table.actionType')"
                :sortable="false" filterField="name"
                :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    <div class="preserve-newlines">
                        {{ data.actionType }}
                    </div>
                </template>
                <template #filter>
                    <CustomSelectOneHistoryActionType name="actionType" v-model="searchCriteria.actionType.value"
                                                    @update:modelValue="search" />
                </template>
            </Column>
            <Column field="actionDescription" :header="$t('message.historyList.table.details')"
                    :sortable="false" filterField="name"
                    :showFilterMenu="false" :showClearButton="false" class="w-4">
                <template #body="{ data }">
                    <span style="white-space: pre-wrap;">
                    {{ data.actionDescription }}
                    </span>
                </template>
            </Column>
            <Column field="referenceId" :header="$t('message.historyList.table.refId')"
                    :sortable="false" filterField="name"
                    :showFilterMenu="false" :showClearButton="false" class="w-1">
                <template #body="{ data }">
                    {{ data.referenceId }}
                </template>
            </Column>
            <Column field="referenceId" :header="$t('message.historyList.table.name')"
                    :sortable="false" filterField="name"
                    :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.horseName }}
                </template>
                <template #filter>
                    <CustomAutocompleteHorse name="horseId" v-model="searchCriteria.horse.value"
                                             @update:modelValue="search" />
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {
    searchHistoryLog,
    searchHistoryLogCount,
} from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import {SearchCriteria} from "@/utils/SearchCriteria";
import {FilterMatchMode} from "primevue/api";
import CustomMultiSelectHorseColor from "@/components/form/CustomMultiSelectHorseColor.vue";
import CustomCalendar from "@/components/form/CustomCalendar.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import CustomMultiSelectDocumentType from "@/components/form/CustomMultiSelectDocumentType.vue";
import CustomSelectOneSystemRole from "@/components/form/CustomSelectOneSystemRole.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {FileUtils} from "@/utils/FileUtils";
import {DateUtils} from "@/utils/DateUtils";
import CustomSelectOneHistoryActionType
    from "@/components/form/CustomSelectOneHistoryActionType.vue";
import CustomAutocompleteHorse from "@/components/form/CustomAutocompleteHorse.vue";

export default {
    name: "HistoryTable",
    components: {
        CustomAutocompleteHorse,
        CustomSelectOneHistoryActionType,
        CustomButton,
        CustomSelectOneSystemRole,
      CustomMultiSelectDocumentType,
        CustomIconButton,
        CustomCalendar,
        Column,
        DataTable,
        CustomInputNumber,
        CustomInputText,
        CustomMultiSelectHorseColor,
    },

    props: {
        modelValue: null,
    },

    data() {
        return {
            loading: false,
            totalRecords: 0,
            documents: [],
            searchCriteria: this.getClearSearchCriteria(),
        };
    },

    mounted() {
        this.searchCriteria = this.getClearSearchCriteria();
        this.search();
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
        },

        onPage(event) {
            this.loading = true;

            this.searchCriteria.page.offset = event.first;
            this.searchCriteria.page.limit = event.rows;
            this.searchCriteria.page.sortField = null;
            this.searchCriteria.page.sortOrder = event.sortOrder ? event.sortOrder : -1;

            const body = SearchCriteria.prepareCriteria(this.searchCriteria, true);
            if (this.searchCriteria ) {
                const range = this.searchCriteria.timestamp.value
                body.timestamp = {};
                if (range) {
                    body.timestamp.min = range[0];
                    body.timestamp.max = range[1];
                }
                if (this.searchCriteria.horse.value) {
                    body.selectedHorseId = this.searchCriteria.horse.value.id
                }
            }


            searchHistoryLog({body}).then((response) => {
                this.documents = response.data;
                return searchHistoryLogCount({body})
                    .then((response) => {
                        this.totalRecords = response.data;
                        this.loading = false;
                    });
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        getClearSearchCriteria() {
            return {
                timestamp: { value: null, matchMode: FilterMatchMode.IN },
                userFullName: { value: null, matchMode: FilterMatchMode.CONTAINS },
                actionType: { value: null, matchMode: FilterMatchMode.CONTAINS },
                horse: {value: null, matchMode: FilterMatchMode.IN},
                role: { value: null, matchMode: FilterMatchMode.IN },
                name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },
        exportCSV() {
            const body = SearchCriteria.prepareCriteria(this.searchCriteria, true);
            FileUtils.downloadFile(body, "history-log-" + DateUtils.timestampNow() +  ".csv", `/history/export/log/csv`);
        }
    },
};
</script>

<style lang="scss">
    .preserve-newlines {
        white-space: pre-line;
    }
</style>
